import React, { useState, useEffect } from 'react';
import { Alert } from 'react-bootstrap';
import { Redirect } from 'react-router';
import '../../styles/AuthenticateUser.css'
import Loading from './Loading';

export function AuthenticateUser() {
    const [loading, setLoading] = useState(true);
    const [authed, setAuthed] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        const fetchLoginStuff = async () => {
            const user = await fetch('/api/login/loginUserByCode/' + window.location.toString().split("code=")[1])
                .then(async (response) => {
                    if (response.status !== 200) {
                        return null;
                    }
                    try {
                        const res = await response.json().then(json => {
                            if (json.errors !== null && json.errors !== "") alert(json.errors)
                            return json.message
                        });
                        return res;
                    }
                    catch (err) {
                        console.log("json error", err);
                        return null;
                    }
                })
                .catch(err => {
                    console.log("response error", err);
                });
            if (user === null) {
                setErrorMessage("You are not allowed to access this section of the application.");
                setTimeout(() => {
                    window.location.href='/login';
                }, 3000);
            }
            else {
                setAuthed(true);
                const completeUser = {
                    isPOCUser: false,
                    sfid: user.id,
                    userID: user.email,
                    roleName: user.role.roleName
                }
                sessionStorage.setItem("user", JSON.stringify(completeUser));
            }
            setLoading(false);
        };
        // if (sessionStorage.getItem("user") !== null) {
        //     window.location.href = '/logout';
        // }
        fetchLoginStuff();
    }, [])

    return (
        <div className="auth-content">
            {(loading && errorMessage.length < 1) 
            && <Loading message="Loading. . . please wait" />
            }
            {errorMessage.length > 1 
            && <Alert variant="danger">{errorMessage}</Alert>
            }
            
            {(authed && !loading && errorMessage.length < 1) 
            && <Redirect to="/all-members"></Redirect>
            }
        </div>
    );
}

